module.exports = __webpack_public_path__ + "img/ppt.12f1f093.svg";